<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Déjà un compte?
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>Ma boutique</h2>
                  <h4>Inscrivez-vous gratuitement pour tester la solution.</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Gérez votre boutique</h5>
                    Ajoutez vos produits, gérez vos commandes et votre inventaire simplement et depuis partout.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-info">
                      <i class="ti-twitter"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Réseaux sociaux</h5>
                    Développez votre présence sur Facebook, Twitter et Instragram automatiquement et sans efforts.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="ti-shopping-cart"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Boutique en ligne</h5>
                    Permettez à vos clients de voir et/ou acheter vos produits directement sur votre site généré automatiquement.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form method="#" action="#">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input v-model="firstname" type="text" placeholder="Prénom" class="form-control">
                      </div>
                      <div class="form-group">
                        <input v-model="lastname" type="text" placeholder="Nom" class="form-control">
                      </div>
                      <div class="form-group">
                        <input v-model="company" type="text" placeholder="Entreprise" class="form-control">
                      </div>
                      <div class="form-group">
                        <input v-validate="'required|email'" v-model="email" type="email" placeholder="Email" class="form-control">
                      </div>
                      <div class="form-group">
                        <input v-model="password" type="password" placeholder="Mot de passe" class="form-control">
                      </div>
                      <div class="form-group">
                        <input v-model="confirmation" type="password" placeholder="Mot de passe (confirmation)" class="form-control">
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" class="btn btn-fill btn-danger btn-wd" @click="register">Gérer mes installations</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/admin">
            Dashboard
          </router-link>
        </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
  import firebase from 'firebase'

  export default {
    data () {
      return {
        email: '',
        password: '',
        confirmation: '',
        company: '',
        firstname: '',
        lastname: ''
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      register () {
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            user.updateProfile({
              displayName: `${this.firstname} ${this.lastname}`
            })
            .catch((error) => {
              console.error(error)
              this.$notify({
                component: {
                  template: `<span>Erreur lors de la mise à jour de votre profil</span>`
                },
                icon: 'ti-alert',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning'
              })
            })
            const userRef = firebase.firestore().collection('users').doc(user.uid)
            const companyRef = firebase.firestore().collection('companies').doc()
            userRef.set({
              email: user.email,
              displayName: `${this.firstname} ${this.lastname}`,
              company: companyRef
            })

            companyRef.set({
              owner: user.uid,
              name: this.company
            }).then(() => {
              companyRef.collection('users').doc(user.uid).set({
                user: userRef,
                permissions: ['all', 'read', 'write'],
                displayName: `${this.firstname} ${this.lastname}`
              })
              .catch((error) => {
                console.log(error)
              })
            })
            .catch((error) => {
              console.log(error)
            })

            user.sendEmailVerification().then(() => {
              this.$router.push('/')
              this.$notify({
                component: {
                  template: `<span>Un email de confirmation a été envoyé à <b>${this.email}</b></span>`
                },
                icon: 'ti-email',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'info'
              })
            }).catch((error) => {
              console.log(error)
            })
          })
          .catch((error) => {
            console.error(error)
            let message = ''
            switch (error.code) {
              case 'auth/email-already-in-use':
                message = 'Cette adresse email est déjà utilisée'
                break
              case 'auth/weak-password':
                message = 'Le mot de passe est trop faible (au moins 6 caractères)'
                break
              default:
                message = error.message
            }
            this.$notify({
              component: {
                template: `<span>${message}</span>`
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning'
            })
          })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue